// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aoLEl","colBig":"styles_colBig__1Rp3w","colSmall":"styles_colSmall__2WsTv"};